// extracted by mini-css-extract-plugin
export default {"color-picker":"ColorPicker_color-picker__jAT0T"};